import { render } from "./instagram1.vue?vue&type=template&id=9111e076"
import script from "./instagram1.vue?vue&type=script&lang=js"
export * from "./instagram1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__